import { FC } from 'react';
import Modal from '@components/Modal';
import SetExternalDataForm from '@/lib/SetExternalDataForm';

type Props = {
  createVersion: boolean;
  existingSlug?: string;
  onClose: () => void;
  onSubmit: () => void
};

const CreateDataReferenceModal: FC<Props> = ({ onClose, onSubmit, createVersion, existingSlug }) => {
  const title = createVersion ? 'Create new data set version' : 'Create new data set';
  return (
    <Modal title={title} onClose={onClose} >
      <SetExternalDataForm
        createVersion={createVersion}
        dataReferenceVersions={null}
        onSubmit={onSubmit}
        existingSlug={existingSlug}
      />
    </Modal>
  );
};

export default CreateDataReferenceModal;